import { useEffect, useState } from "react";
import api from "../lib/api";
import { ReelsFeed } from "../components/ReelsFeed";

const Feed = () => {
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    api.get("/videos?sort=recent").then((r) => setVideos(r.data)).catch(() => setVideos([]));
  }, []);

  if (videos === null) {
    return <div className="h-[calc(100vh-6.5rem)] flex items-center justify-center text-zinc-500">Loading feed…</div>;
  }
  return <ReelsFeed videos={videos} emptyText="No videos yet. Be the first artist to upload!" />;
};

export default Feed;
